import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const getAuctionMaxBet: TComputedPropMapper<number> = ({ offer: { auction } }) => {
  return auction?.maxAvailableBet || 99;
};
